// extracted by mini-css-extract-plugin
export default {"genericCard":"qr-z","inline":"rr-z","mastercard":"sr-z","discover":"tr-z","visa":"ur-z","amex":"vr-z","active":"wr-z"};